// extracted by mini-css-extract-plugin
export default {"Conteudo":"estilo_Conteudo__lNRhF","Mensagem":"estilo_Mensagem__Rf+3e"};